import React from 'react';

import type { MonitoringHit } from '@tf/shared';
import { getResultHit, ScreeningResultCard } from '@tf/shared';

interface Props {
	hit: MonitoringHit | null;
}

export const MonitoringMatchCard: React.FC<Props> = ({ hit }) => {
	if (!hit) {
		return null;
	}

	return <ScreeningResultCard hit={getResultHit(hit)} />;
};
